import { LANGUAGES, type SupportedLanguage, type UiCopy } from '../i18n/uiCopy';

export function TopBar({
  copy,
  language,
  onLanguageChange
}: {
  copy: UiCopy;
  language: SupportedLanguage;
  onLanguageChange: (lang: SupportedLanguage) => void;
}) {
  return (
    <div className="topbar">
      <a className="brand" href="/">
        <span className="brand-mark" aria-hidden="true">
          📦
        </span>
        {import.meta.env.VITE_CARRIER_NAME}
      </a>
      <select
        className="lang-select"
        aria-label={copy.languageLabel}
        value={language}
        onChange={(e) => onLanguageChange(e.target.value as SupportedLanguage)}
      >
        {LANGUAGES.map((l) => (
          <option key={l.code} value={l.code}>
            {l.label}
          </option>
        ))}
      </select>
    </div>
  );
}
